import { useState, useEffect } from "react"
import authService from "../services/authService"

const useAuth = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(authService.isAlreadyLogin())
    const [userInfo, setUserInfo] = useState(authService.getUserInfo())

    useEffect(() => {
        setUserInfo(authService.getUserInfo())
    }, [isAuthenticated])

    const authObject = { isAuthenticated, setIsAuthenticated }

    return { authObject, userInfo }
}

export { useAuth }